export default __webpack_public_path__ + "static/media/verticalIcon.d1992805.svg";